import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseProduct } from 'src/app/shared/product/baseProduct';
import { ReservationStepOneComponent } from './components/reservation-step-one/reservation-step-one.component';
import { ReservationStepThreeComponent } from './components/reservation-step-three/reservation-step-three.component';
import { ReservationStepTwoComponent } from './components/reservation-step-two/reservation-step-two.component';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ImageService } from '../../services/image.service';
import { ImageUploadHandlerService } from '../../../../../shared/services/image-upload-handler.service';
import { PostProductStepService } from '../../services/post-product-step.service';
import { FetchProductService } from '../../services/fetch-product.service';
import { FetchProdcutNameService } from '../../services/fetch-product-name.service';
import { ProductStepHandlingService } from '../../services/product-step-handling.service';
import { ProductTypes } from '../../../../../shared/product/productTypes';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';
import { BasicStepOneTemplateService } from '../basic-info/services/basic-step-one-template.service';
import { toggleProductExtraInfoFlag } from '../../../../../shared/utils/productUtils';
declare let $: any;
@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent extends BaseProduct implements OnInit {

  @ViewChild(ReservationStepOneComponent) stepOne!: ReservationStepOneComponent;
  @ViewChild(ReservationStepTwoComponent) stepTwo!: ReservationStepTwoComponent;
  @ViewChild(ReservationStepThreeComponent) stepThree!: ReservationStepThreeComponent;
  isUpdate: any =false;
  id: any;
  productObject: any;
  similarProducts: any[] = [];
  subscriptions: any[] = [];
  productIsCopied = false;
  isBuyerInfoFormValid = false;
  currentStep: number = 1;
  hasNoTicket: boolean = false;
  isSubmitting: boolean = false;
  searchableSelectDefaultValue: any;
  listCurrentIcon: string = '../../../../../assets/icons/list.svg';
  responsiveCurrentIcon: string = '../../../../../assets/icons/responsive.svg';
  globeCurrentIcon: string = '../../../../../assets/icons/globe.svg';
  listIcon: string = '../../../../../assets/icons/list-muted.svg';
  responsiveIcon: string = '../../../../../assets/icons/responsive-muted.svg';
  globeIcon: string = '../../../../../assets/icons/globe-muted.svg';

  constructor(
    imageUploadRqst: ImageService,
    imageUpload: ImageUploadHandlerService,
    private postStep: PostProductStepService,
    dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private fetchProductService: FetchProductService,
    private fetchProdcutNameService: FetchProdcutNameService,
    public stepHandlerService: ProductStepHandlingService,
    public translate: TranslateService,
    private languageService: LanguageService,
    private basicStepOneTemplateService: BasicStepOneTemplateService
  ) {
    super(imageUpload, imageUploadRqst, dialog);
  }

  async ngOnInit() {
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.productName = ProductTypes.Reservation;
    await this.prepareSimilarProducts();
    this.stepTwo.from.valueChanges.subscribe((value: any) => {
      this.hasNoTicket = value && value.Ticket && value.Ticket.length ? false : true;
    });
    this.stepHandlerService.isBuyerInfoFormValid.subscribe(value => {
      this.isBuyerInfoFormValid = value
    })
    this.activatedRoute.params.subscribe(async (params) => {
      if (params['id']) this.isUpdate = true;
    });
  }

  async ngAfterViewInit() {
    await this.stepOne.asyncUpdateForm()
    this.activatedRoute.params.subscribe(async (params) => {
      if (params['id']) {
        this.id = params['id'];
        this.fetchProductService.setParams({
          id: this.id,
          type: ProductTypes.Reservation,
        });
        this.productObject = await this.fetchProductService.make();
        if (this.isUpdate && this.productObject) {
          toggleProductExtraInfoFlag(this.productObject, 'VATOnSellerFlag');
          this.applyValuesToFields(this.productObject);
        }
      }else {
        const formValue =
          await this.basicStepOneTemplateService.getObjectToPatch(
            this.stepOne.productName
          );
        if (formValue) this.stepOne.stepForm.patchValue(formValue);
      }
    });
    this.forms = [this.stepOne, this.stepTwo, this.stepThree];
    this.stepOne.from.controls['Payment options'].valueChanges.subscribe(() => {
      if (this.currentStep == 1) {
        let paymentOptions = this.stepOne.from.controls['Payment options'].value;
        if (!paymentOptions || paymentOptions.length < 1) {
          this.stepOne.from.controls['Payment options'].setErrors({
            required: true
          });

          this.stepOne.formValidator.forceShowErrors();
        }
      }
    });
  }

  async  submit() {
    this.isSubmitting = true;
    let imagePath;
    if (typeof this.StepsValue["Reservation Image"] == 'object') {
      imagePath = (await this.uploadImage(this.StepsValue["Reservation Image"])).location || null;
    } else {
      imagePath = this.StepsValue["Reservation Image"] || null;
    }
    //deposit amount validation
    const depositAmount = Number(this.StepsValue['Do you want Qasatly Deposit?'])
    let ticketPrice = Number(this.StepsValue['Ticket'][0].Price);
    for (let ticket of this.StepsValue['Ticket']) {
      if (ticket.Price < ticketPrice) ticketPrice = Number(ticket.Price);
    }
    const depositValidation =this.qasatlyDepositValidation(
      this.stepOne.stepForm.controls['Do you want Qasatly Deposit?'],
      this.stepOne.formValidator,
      ticketPrice,
      depositAmount
    );
    if (depositValidation) {
      this.goToStep(1);
      return
    };
    let productValues = {
      ...this.StepsValue,
      "Reservation Image": imagePath,
      type: ProductTypes.Reservation,
      "editing": this.isUpdate,
      "productId": this.id,
    };

    if (!productValues['TaxesQuestion']) {
      productValues['Taxes'] = 0;
      productValues['Type'] = '';
    }

    let defaultBuyerInfos = [
      {
        id: "",
        fieldName: "Name",
        fieldRequired: true,
        fieldType: "1",
        value: [],
      },
      {
        id: "",
        fieldName: "Email",
        fieldRequired: true,
        fieldType: "1",
        value: [],
      },
      {
        id: "",
        fieldName: "Phone",
        fieldRequired: true,
        fieldType: "1",
        value: [],
      },
    ];

    let buyerInfos = this.stepThree.stepForm.controls['buyerInfos'].value || productValues["buyerInfos"];
    let thereIsDublickts: boolean = this.stepThree.FormBuilder.dublicetIndex > -1;
    if (thereIsDublickts) {
      thereIsDublickts = !thereIsDublickts;
    }
    productValues["buyerInfos"] = [
      ...buyerInfos,
      ...defaultBuyerInfos,
    ];
    productValues["Do you want the VAT to be on buyer?"] = !productValues["Do you want the VAT to be on buyer?"];
    this.postStep.setParams(productValues);
    let result = await this.postStep.make();

    window.location.href = result.product.code + "?showWindow=" + (this.isUpdate ? "update" : "create");
    this.isSubmitting = false;
  }

  public applyValuesToFields(data: any) {
    this.stepOne.stepForm.patchValue({
      "After Payment Message": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "afterPaymentMessage"
      ),
      Currency: this.getNewFieldValueByKey(data.ProductExtraInfos, "currency"),
      "Do you want the fees to be on the buyer?": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "feesOnBuyerFlag"
      ),
      "Do you want the fees to be split between buyer and seller?": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "splitFees"
      ),
      "Do you want the VAT to be on buyer?": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "VATOnSellerFlag"
      ),
      "Do you want to send an SMS to the buyer after purchase? with a cost 0.5 EGP": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "SendSmsFlag"
      ),
      "sendWhatsAppMsgAfterTrxToBuyer": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "sendWhatsAppMsgAfterTrxToBuyer"
      ) ?? false,
      "Do you want Qasatly Deposit?": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "qasatlyDeposit"
      ) | 0,
      "Do you want this reservation on your shop?": true,
      "Do you want to show this reservation on your shop?": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "showOnShop"
      ),
      "Reservation description": this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        "description"
      ),
      "Reservation name": data.productName,
      "Expiry date": data.expiryDate,
      "Payment options": data.paymentOptions,
      'cash options' : this.getNewFieldValueByKey(
        data.ProductExtraInfos,
        'cashExpiryDate'
      )
    });

    this.stepTwo.stepForm.patchValue({
      "Delivery terms": data.ReservationProductExtraInfo.deliveryTerms,
      "Return terms": data.ReservationProductExtraInfo.returnTerms,
      'Reservation Image': data.ReservationProductExtraInfo.image,
    });
    this.requireFields(data)

    if (data.ProductTax) {
      this.stepOne.stepForm.controls['TaxesQuestion'].setValue(+data.ProductTax.taxes > 0);
      this.stepOne.stepForm.controls['Type'].setValue(data.ProductTax.type);
      this.stepOne.stepForm.controls['Taxes'].setValue(data.ProductTax.taxes);
      this.stepOne.isTaxesApplied = +data.ProductTax.taxes > 0;
    } else {
      this.stepOne.stepForm.controls['TaxesQuestion'].setValue(false);
      this.stepOne.stepForm.controls['Type'].setValue('');
      this.stepOne.stepForm.controls['Taxes'].setValue(0);
      this.stepOne.isTaxesApplied = false;
    }
    if (data.BuyerInfoFields && data.BuyerInfoFields.length > 3) {
      this.isBuyerInfoFormValid = true
      this.stepTwo.stepForm.controls[this.stepTwo.controllers['is_buyer_info'].fieldName].setValue(true)
    }
  }

  requireFields(data: any) {
    let id;
    let ticketsArray: any[] = [];
    this.stepTwo.tickets.ticketsItem.removeAt(0);
    data.ReservationTickets.forEach((ele: any) => {
      this.isUpdate == true ? id = ele.id : id = ""
      let ticketObject = {
        "id": id,
        "Total Quantity": ele.quantity,
        "Available Db Quantity": ele.quantity - ele.pendingQuantity - ele.paidQuantity,
        "original Quantity": +ele.pendingQuantity + +ele.paidQuantity,
        Price: ele.price,
        "Pending Quantity": ele.pendingQuantity,
        "Paid Quantity": ele.paidQuantity,
        "Ticket expiry": ele.expiry,
        "Ticket name": ele.name,
        "Max Quantity Per Sale": ele.maxQuantityPerSale
      }
      this.stepTwo.tickets.populateTicket(ticketObject);
      ticketsArray.push(ticketObject);
    });
    this.stepTwo.tickets.populateAllTickets(ticketsArray);
  }

  mapNewProductNames(fieldName: any) {
    switch (fieldName) {
      case "Physical Product name":
        return "name";
      case "Physical Product description":
        return "description";
      case "Expiry date":
        return "expiryDate";
      case "After Payment Message":
        return "afterPaymentMessage";
      case "Currency":
        return "currency";
      case "Do you want to show this physical product on your shop?":
        return "showOnShop";
      case "Do you want the fees to be on the buyer?":
        return "feesOnBuyerFlag";
      case "Do you want the fees to be split between buyer and seller?":
        return "splitFees";
      case "Do you want the VAT to be on buyer?":
        return "VATOnSellerFlag";
      case 'Do you want Qasatly Deposit?':
        return 'qasatlyDeposit'
      case "Payment options":
        return "paymentOptions";
      case "Product Image":
        return "image";
      case "Category":
        return "name";
      case "id":
        return "id";
      case "Product Price":
        return "price";
      case "Available Quantity":
        return "Available Quantity";
      case "original Quantity":
        return "original Quantity"
      case 'Pending Quantity':
        return 'pendingQuantity'
      case 'Paid Quantity':
        return 'paidQuantity'
      case "Delivery terms":
        return "deliveryTerms";
      case "Return terms":
        return "returnTerms";
      case 'cash options':
        return 'cashExpiryDate';
      default:
        return null;
    }
  }

  getNewFieldValueByKey(fieldValues: any[], name: string) {
    return (fieldValues.find((fv) => fv.key === name) || {})?.value;
  }

  async prepareSimilarProducts() {
    this.fetchProdcutNameService.setParams({
      filterOptions: {
        published: "1",
        productType: ProductTypes.Reservation,
      },
      sortOptions: {
        productName: "ASC",
      },
    });
    const result = await this.fetchProdcutNameService.make();
    this.similarProducts = result;
  }

  async onProductSelection(event: any) {
    let selectedId = event.target.value;
    this.productIsCopied = true;
    this.fetchProductService.setParams({
      id: selectedId,
      type: ProductTypes.Reservation,
    });
    const result = await this.fetchProductService.make();
    this.productObject = result;
    console.log('productObject', this.productObject);
    this.applyValuesToFields(this.productObject);
    for (let i = this.currentStep; i > 1; i--) {
      --this.currentStep;
    }
  }

  async goToStep(order: any) {
    let steps;
    let isStepClicked=true;
    if (order < this.currentStep) {
      steps = this.currentStep - order;
      for (let i = steps; i > 0; i--) {
        this.navigateToStep("prev");
      }
    } else if (order > this.currentStep) {
      steps = order - this.currentStep;
      for (let i = steps; i > 0; i--) {
        this.navigateToStep("next",isStepClicked);
      }
    }
  }

  async navigateToStep(navigation: string,isClickStep:boolean=false) {
    let noTicket = this.stepTwo.tickets.noTicket;
    if (this.isCurrentStepValid() && !noTicket) {
      const isBeforeTheLastStep = this.isStepBeforeBuyerInfoStep();
      if (isBeforeTheLastStep) {
        this.getBuyerInfoTogglerChoice();
        if (!this.canGoToBuyerInfoStep && navigation == 'next') {
          if(!isClickStep) await this.submit();
        } else {
          if (navigation == 'next') {
            ++this.currentStep;
          } else {
            --this.currentStep;
          }
          $("html, body").animate({
            scrollTop: 0
          });
        }
      } else {
        if (navigation == 'next') {
          ++this.currentStep;
        } else {
          --this.currentStep;
        }
        $("html, body").animate({
          scrollTop: 0
        });
      }
    }
    else {
      if (navigation == 'prev') {
        --this.currentStep;
      }
      $("html, body").animate({
        scrollTop: 0
      });
    }
  }

}
